// TO-Do (rajitha): Will configure images input type during BFF integration
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { ImageCarouselAriaLabels } from './models/image-carousel.interfaces';
import { ActivecarouselService } from './service/activecarousel.service';
export type LoadingStrategyType = 'eager' | 'lazy';

@Component({
  selector: 'idp-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent {
  @ViewChildren('carouselitem') carouselitems!: QueryList<any>;
  @ViewChildren('carouselind') carouselind!: QueryList<any>;
  @Input() images: any;
  @Input() description: string | undefined;
  @Input() showCarouselNextPrev!: boolean;
  @Input() loadingStrategy: LoadingStrategyType = 'eager';
  @Output() failure: EventEmitter<ErrorEvent> = new EventEmitter();
  @Input() ariaLabel: ImageCarouselAriaLabels = {
    previous: 'Previous',
    next: 'Next'
  };

  constructor(
    public elem: ElementRef,
    public elem2: ElementRef,
    private activeCarouselService: ActivecarouselService
  ) {}

  GoToCarousel(event: any, index: any) {
    event.preventDefault();
    let prev = false;
    for (let i = 0; i < this.carouselitems.toArray().length; i++) {
      prev = this.handleActiveCarousels(i, index, prev);
    }
    for (let i = 0; i < this.carouselind.toArray().length; i++) {
      if (
        this.carouselind.toArray()[i].nativeElement.classList.contains('active')
      ) {
        this.carouselind.toArray()[i].nativeElement.classList.remove('active');
        this.carouselind.toArray()[index].nativeElement.classList.add('active');
      }
    }
    this.handlePrevNextCarousels(prev);
    event.stopPropagation();
  }

  defaultCarousel(elem: ElementRef, elem2: ElementRef) {
    this.updateClassList(elem, 'add', ['carousel-item-left']);
    this.updateClassList(elem2, 'add', [
      'carousel-item-left',
      'carousel-item-next'
    ]);
    this.updateClassList(elem, 'remove', ['active', 'carousel-item-left']);
    this.updateClassList(elem2, 'remove', [
      'carousel-item-left',
      'carousel-item-next'
    ]);
    this.updateClassList(elem2, 'add', ['active']);
  }

  updateClassList(elem: ElementRef, action: string, classList: Array<string>) {
    if (action == 'add') {
      elem.nativeElement.classList.add(...classList);
    } else if (action == 'remove') {
      elem.nativeElement.classList.remove(...classList);
    }
  }

  handlePrevNextCarousels(prev: any) {
    if (this.elem !== undefined && this.elem2 !== undefined) {
      if (prev) {
        this.elem.nativeElement.classList.add('carousel-item-right');
        this.elem2.nativeElement.classList.add('carousel-item-right');
        this.elem2.nativeElement.classList.add('carousel-item-prev');
        this.elem.nativeElement.classList.remove('active');
        this.elem.nativeElement.classList.remove('carousel-item-right');
        this.elem2.nativeElement.classList.remove('carousel-item-right');
        this.elem2.nativeElement.classList.remove('carousel-item-prev');
        this.elem2.nativeElement.classList.add('active');
      } else this.defaultCarousel(this.elem, this.elem2);
    }
  }

  handleActiveCarousels(i: any, index: any, prev: any) {
    if (
      this.carouselitems.toArray()[i].nativeElement.classList.contains('active')
    ) {
      this.elem = this.carouselitems.toArray()[i];
      if (index > i) {
        this.elem2 = this.carouselitems.toArray()[index];
        return false;
      } else if (index < i) {
        this.elem2 = this.carouselitems.toArray()[index];
        return true;
      }
    }
    return prev;
  }

  assignValueToElem(i: number, imgLength: number): void {
    if (
      this.carouselitems.toArray()[i].nativeElement.classList.contains('active')
    ) {
      this.elem = this.carouselitems.toArray()[i];
      this.elem2 =
        i !== imgLength - 1
          ? this.carouselitems.toArray()[i + 1]
          : this.carouselitems.toArray()[0];
    }
  }

  showNextCarousel(event: any): void {
    const imgLength = this.carouselitems.toArray().length;
    for (let i = 0; i < imgLength; i++) this.assignValueToElem(i, imgLength);
    if (this.elem && this.elem2) {
      this.defaultCarousel(this.elem, this.elem2);
    }
    this.activeCarouselService.syncActiveCarouselArrowAndSlider(
      event,
      this.carouselind,
      this.carouselitems
    );
  }

  assignElem(i: number, imgLength: number): void {
    if (
      this.carouselitems.toArray()[i].nativeElement.classList.contains('active')
    ) {
      this.elem = this.carouselitems.toArray()[i];
      this.elem2 =
        i !== 0
          ? this.carouselitems.toArray()[i - 1]
          : (this.elem2 = this.carouselitems.toArray()[imgLength - 1]);
    }
  }

  showPrevCarousel(event: any): void {
    const imgLength = this.carouselitems.toArray().length;
    for (let i = 0; i < imgLength; i++) this.assignElem(i, imgLength);
    if (this.elem && this.elem2) this.defaultCarousel(this.elem, this.elem2);
    this.activeCarouselService.syncActiveCarouselArrowAndSlider(
      event,
      this.carouselind,
      this.carouselitems
    );
  }
}
